import { render, staticRenderFns } from "./Broadcasts.vue?vue&type=template&id=55ead433&scoped=true"
import script from "./Broadcasts.vue?vue&type=script&lang=js"
export * from "./Broadcasts.vue?vue&type=script&lang=js"
import style0 from "./Broadcasts.vue?vue&type=style&index=0&id=55ead433&prod&scoped=true&lang=css"
import style1 from "./Broadcasts.vue?vue&type=style&index=1&id=55ead433&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ead433",
  null
  
)

export default component.exports